// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ca8777b9","453":"443a0f0c","732":"94688a94","977":"65104f09"}[chunkId] + ".chunk.js";
};